import React, { useCallback, useState } from 'react';

import { Select, TextInput, NumericInput, ImageUpload } from '../EditorFormElements';
import { Collapsible, FormFieldWrapper } from '../Global';

import makePath from '../../utils/makePath';

const typeOptions = [
  {
    value: '',
    label: ''
  },
  {
    value: 'text',
    label: 'Text'
  },
  {
    value: 'image',
    label: 'Image'
  }
]

const verticalAlignmentOptions = [
  {
    value: '',
    label: ''
  },
  {
    value: 'inside-top',
    label: 'Inside Top'
  },
  {
    value: 'inside-bottom',
    label: 'Inside Bottom'
  },
  {
    value: 'outside-top',
    label: 'Outside Top'
  },
  {
    value: 'outside-bottom',
    label: 'Outside Bottom'
  }
]

const horizontalAlignmentOptions = [
  {
    value: '',
    label: ''
  },
  {
    value: 'inside-left',
    label: 'Inside Left'
  },
  {
    value: 'inside-right',
    label: 'Inside Right'
  },
  {
    value: 'outside-left',
    label: 'Outside Left'
  },
  {
    value: 'outside-right',
    label: 'Outside Right'
  }
]

export const Panel = React.memo(({given = {}, ...props}) => {
  const [format, setFormat] = useState('');
  
  const onSelectChange = useCallback((name,value) => {
    setFormat(value);
  }, [setFormat])

  const path = makePath(props.path, props.index)

  return (
    <Collapsible headerTag="h6" title={`Panel ${props.index + 1}`} sortableChild>
      
      <FormFieldWrapper>

        <Select 
          name="format"
          label="Format"
          options={typeOptions}
          callback={onSelectChange}
          help="If changed, you will lose content provided for the other format."
          path={path}
          given={given.format}
        />

      </FormFieldWrapper>

      {format === 'text' ?
        <FormFieldWrapper>
          <TextInput 
            name="text"
            label="Text"
            path={path}
            multiline
            rows={2}
            defaultText="Provide text for this panel."
            given={given.text}
          />

          <NumericInput
            name="width"
            label="Width"
            defaultNumber={315}
            min={1}
            help="Enter panel width in pixels (recommended range is 315-579) to ensure text wraps properly to the next line."
            path={path}
            given={given.width}
          />
        </FormFieldWrapper>
      : ''}

      {format === 'image' ?
        <>
          <FormFieldWrapper>
            <ImageUpload 
              name="image"
              label="Image"
              tooltip="Upload an image to display in this panel. Recommended image widths (pixels): 315, 380, 445, 665. File sizes should not exceed 75KB."
              path={path}
              given={given.image}
            />
          </FormFieldWrapper>

          <FormFieldWrapper>
            <TextInput 
              name="caption"
              label="Caption"
              multiline
              rows={5}
              path={path}
              given={given.caption}
              defaultText="Provide text as a story caption for this panel."
            />

            <TextInput 
              name="screenreaderCaption"
              label="Screenreader Caption"
              multiline
              rows={5}
              placeholder="If the caption does not stand alone well enough to explain the scenario to screen reader users, provide an alternate caption for screen readers only."
              path={path}
              given={given.screenreaderCaption}
              validationCriteria={{
                optional:true,
              }}
              help="This field is optional."
            />
          </FormFieldWrapper>

          <h6 className="form-section-header">Caption Position</h6>

          <FormFieldWrapper>
            <Select 
              name="vertAlign"
              label="Vertical Alignment"
              options={verticalAlignmentOptions}
              path={path}
              given={given.vertAlign}
            />

            <Select 
              name="horzAlign"
              label="Horizontal Alignment"
              options={horizontalAlignmentOptions}
              path={path}
              given={given.horzAlign}
            />
          </FormFieldWrapper>
        </>
      : ''}

      {props.deleteBtn}

    </Collapsible>
  )

})
 